export default () => {
  return {
    /**
     * Clinic the cache below belongs to. Support access moves a user between clinics without a
     * reload, so the cache has to be dropped when this stops matching.
     */
    clinicId: null,

    /**
     * Integration references, cached per object type ('staff' | 'client'). A clinic can hold tens
     * of thousands of references, so these are read once and refreshed only when they actually
     * change.
     */
    referencesCache: {},

    /**
     * Linked profile names for each object type. Read from `getReferencesLinks` on every
     * `loadReferences()` call — unlike the reference list, this costs no client-side Firestore
     * reads, and caching it would leave a link made by another admin invisible for the session.
     */
    linkedNamesCache: {},

    staleTypes: {},

    /**
     * Tracks an in-flight `loadReferences()` promise per object type, so a second call made while
     * one is still running (e.g. canceling and reopening the link dialog) joins it instead of
     * starting a duplicate paginated read.
     */
    pendingLoads: {},

    invalidationNotifications: [],
    isInvalidationBound: false,
    // In-flight `bindReferencesInvalidation()` promise, so a second caller (e.g. `staff` and
    // `client` loading in parallel) joins it instead of starting its own bind attempt.
    pendingInvalidationBind: null,

    /**
     * `invalidationNotifications` accumulates every notification live for the last 4 hours
     * (`clearRealTimeNotifications`), not just the new one on each snapshot. Tracks which ids were
     * already turned into an `invalidateReferences()` call, so a later snapshot doesn't re-mark an
     * untouched object type stale just because it shares a batch with a genuinely new notification.
     */
    handledNotificationIds: {},
  };
};
